import { createAction } from '@reduxjs/toolkit';

export const nonTradingEventUpdate = createAction('nonTradingEventUpdate', (data) => {
    const {
        id,
        extra_info,
        match_status,
    } = data;
    const raceState = extra_info?.race_state;
    const normalizedMatchStatus = match_status || raceState;

    const normalizedEvent = {
        id: String(id),
        ...(normalizedMatchStatus && { match_status: normalizedMatchStatus }),
    };

    let normalizedScoreBoard = {};

    if (extra_info) {
        normalizedScoreBoard = {
            id: String(id),
            ...extra_info,
        };
    }

    return {
        payload : {
            event: normalizedEvent,
            scoreboard: normalizedScoreBoard,
        },
    };
});
